import { memo } from 'react';

import LessonIcon from '@/components/_deprecated/lessons/LessonIcon';

type Props = {
  progress: number;
  banner?: string;
};

const LessonProgressRoundedBar = memo((props: Props) => {
  const { banner = '', progress } = props;

  return <LessonIcon lessonBanner={banner} progress={progress} />;
});

export default LessonProgressRoundedBar;
